import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip'
import { cn } from '@/lib/utils'

function TooltipProvider({ delay = 150, ...props }: TooltipPrimitive.Provider.Props) {
    return <TooltipPrimitive.Provider data-slot='tooltip-provider' delay={delay} {...props} />
}

function Tooltip({ ...props }: TooltipPrimitive.Root.Props) {
    return <TooltipPrimitive.Root data-slot='tooltip' {...props} />
}

function TooltipTrigger({ ...props }: TooltipPrimitive.Trigger.Props) {
    return <TooltipPrimitive.Trigger data-slot='tooltip-trigger' {...props} />
}

function TooltipContent({
    className,
    side = 'top',
    sideOffset = 6,
    align = 'center',
    children,
    ...props
}: TooltipPrimitive.Popup.Props & Pick<TooltipPrimitive.Positioner.Props, 'align' | 'side' | 'sideOffset'>) {
    return (
        <TooltipPrimitive.Portal>
            <TooltipPrimitive.Positioner align={align} side={side} sideOffset={sideOffset} className='isolate z-50'>
                <TooltipPrimitive.Popup
                    data-slot='tooltip-content'
                    className={cn(
                        'z-50 max-w-xs origin-(--transform-origin) rounded-lg bg-forest px-3 py-1.5 text-xs font-medium text-ivory shadow-card data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0',
                        className
                    )}
                    {...props}
                >
                    {children}
                </TooltipPrimitive.Popup>
            </TooltipPrimitive.Positioner>
        </TooltipPrimitive.Portal>
    )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
